/**
 * Dry Storage Management Models
 */

export interface StorageRackDto {
  id: string;
  marinaId: string;
  name: string;
  rackCode: string;
  totalLevels: number;
  slotsPerLevel: number;
  description?: string;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface DryDockLocationDto {
  id: string;
  marinaId: string;
  name: string;
  description?: string;
  isOccupied: boolean;
  isUnavailable: boolean;
  rackId?: string;
  level?: number;
  positionIndex?: number;
  maxLengthFt?: number;
  maxBeamFt?: number;
  maxHeightFt?: number;
  maxWeightLbs?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateStorageRackRequest {
  name: string;
  rackCode: string;
  totalLevels: number;
  slotsPerLevel: number;
  description?: string;
  defaultMaxLengthFt?: number;
  defaultMaxBeamFt?: number;
  defaultMaxHeightFt?: number;
  defaultMaxWeightLbs?: number;
}

export interface UpdateStorageRackRequest {
  name?: string;
  rackCode?: string;
  description?: string;
  isArchived?: boolean;
}

export interface UpdateDryDockLocationRequest {
  name?: string;
  description?: string;
  isUnavailable?: boolean;
  maxLengthFt?: number;
  maxBeamFt?: number;
  maxHeightFt?: number;
  maxWeightLbs?: number;
}

export interface UpdateLevelConstraintsRequest {
  level: number;
  maxLengthFt?: number;
  maxBeamFt?: number;
  maxHeightFt?: number;
  maxWeightLbs?: number;
}

export interface FilterSlotsByBoatDimensionsRequest {
  marinaId?: string;
  rackId?: string;
  lengthFt?: number;
  beamFt?: number;
  heightFt?: number;
  weightLbs?: number;
  includeOccupied?: boolean;
  includeUnavailable?: boolean;
  onlyCompatible?: boolean;
}

